import { HomeIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack/stack";
import { Typography } from "@/core/components/ui/typography";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Stack gap="lg" align="center">
        <Typography variant="subtitleW1" className="text-4xl">
          Oops!
        </Typography>
        <Typography textColor="secondary" variant="bodyW1">
          We can't seem to find the page you're looking for.
        </Typography>
        <Button asChild variant="text">
          <Link to="/" className="flex items-center gap-2">
            <HomeIcon className="h-4 w-4" />
            Back Home
          </Link>
        </Button>
      </Stack>
    </div>
  );
}
